const firstPresentId = (...values: unknown[]): string | number | null => {
  for (const value of values) {
    if (value != null && value !== "") {
      return value as string | number;
    }
  }
  return null;
};

/**
 * Staff profile lookups need a subscriber id. The docupload route's `:id` is the
 * transaction id, so it must not be sent as subscriberID. Applicant tokens cannot
 * call the staff property and application-profile endpoints at all.
 */
export const resolveSubscriberIdForStaffProfile = ({
  isApplicantViewer,
  recordSubscriberId,
  proofSubscriberId,
  applicantSubscriberId,
  officeId,
  routeId,
}: {
  isApplicantViewer: boolean;
  recordSubscriberId?: unknown;
  proofSubscriberId?: unknown;
  applicantSubscriberId?: unknown;
  officeId?: unknown;
  routeId?: unknown;
}): string | number | null => {
  if (isApplicantViewer) {
    return null;
  }

  return firstPresentId(
    recordSubscriberId,
    proofSubscriberId,
    applicantSubscriberId,
    officeId,
    routeId
  );
};
